import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { Box } from "@mui/system";
import { Paper } from "@mui/material";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const PlayerProfileLineChart = ({ chartName, rawData }) => {
  const data = {
    labels: rawData["left"].map((item, index) => `Point ${index}`),
    datasets: [
      {
        label: "Left",
        data: rawData["left"],
        borderColor: "#D44225",
        pointStyle: "rectRot",
        borderWidth: 1,
      },
      {
        label: "Right",
        data: rawData["right"],
        borderColor: "#25D477",
        pointStyle: "rectRot",
        borderWidth: 1,
      },
      {
        label: "Combined",
        data: rawData["combined"],
        borderColor: "#1d428a",
        pointStyle: "rectRot",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        align: "center",
        labels: {
          boxWidth: 12,
          usePointStyle: false,
        },
      },
      title: {
        display: true,
        text: chartName,
      },
    },

    scales: {
      // to remove the labels
      x: {
        ticks: {
          display: false,
        },
        grid: {
          display: false,
        },
      },
    },
  };
  return (
    <Box id="chart" style={{ width: "100%" }}>
      <Box mt={2} mb={2}>
        <Paper elevation={2} sx={{ backgroundColor: "#F5F5F5" }}>
          <Line data={data} options={options} />
        </Paper>
      </Box>
    </Box>
  );
};

export default PlayerProfileLineChart;
